'use client';

import { c as _c } from "react/compiler-runtime";
import type { Provider } from '@repo/api-gw-sdk';
import { ResourceType } from '@repo/api-gw-sdk';
import { useMemo } from 'react';
import { useEnvironment } from '@/contexts/useEnvironment';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';
import { ResourceTypes } from './resourceTypes';
const wipResourceTypes = [ResourceType.ResourceTypeUnspecified, ResourceType.AwsEfs, ResourceType.AwsFsx, ResourceType.AwsKeyspacesTable, ResourceType.AwsCassandraCluster, ResourceType.GcpCassandraCluster, ResourceType.AzureCassandraCluster, ResourceType.AwsNeptune, ResourceType.AzureFileShare, ResourceType.AzureDisk, ResourceType.AzureSapHanaVm, ResourceType.GcpSapHanaVm, ResourceType.AzureSqlDatabase, ResourceType.AzureSqlManagedInstance, ResourceType.AzureMysql, ResourceType.AzureCosmosdbMongodb, ResourceType.AzureCosmosdbNosql, ResourceType.AzureAksNamespace, ResourceType.GcpGkeNamespace, ResourceType.GcpCloudFirestore, ResourceType.GoogleWorkspaceResource, ResourceType.Microsoft365Resource, ResourceType.AzureEntraIdResource];
export const useSupportedResourceTypes = t0 => {
  const $ = _c(33);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cloudProviders = t1;
  const {
    isDemo,
    isDev
  } = useEnvironment();
  const {
    AzureSqlDatabaseSupport,
    AzureSqlDiscovery,
    SapHanaPitrSupport,
    AwsKeyspacesSupport,
    CassandraSupport,
    AzureFilesSupport,
    GoogleWorkspaceSupport,
    m365BackupConsole,
    EntraIdSupport
  } = useFeatureFlags();
  let t2;
  if ($[2] !== AwsKeyspacesSupport) {
    t2 = AwsKeyspacesSupport ? [ResourceType.AwsKeyspacesTable] : [];
    $[2] = AwsKeyspacesSupport;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== CassandraSupport) {
    t3 = CassandraSupport ? [ResourceType.AwsCassandraCluster, ResourceType.GcpCassandraCluster, ResourceType.AzureCassandraCluster] : [];
    $[4] = CassandraSupport;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== AzureSqlDatabaseSupport || $[7] !== AzureSqlDiscovery) {
    t4 = AzureSqlDatabaseSupport || AzureSqlDiscovery ? [ResourceType.AzureSqlDatabase] : [];
    $[6] = AzureSqlDatabaseSupport;
    $[7] = AzureSqlDiscovery;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== SapHanaPitrSupport) {
    t5 = SapHanaPitrSupport ? [ResourceType.AzureSapHanaVm, ResourceType.GcpSapHanaVm] : [];
    $[9] = SapHanaPitrSupport;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== AzureFilesSupport) {
    t6 = AzureFilesSupport ? [ResourceType.AzureFileShare] : [];
    $[11] = AzureFilesSupport;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== GoogleWorkspaceSupport) {
    t7 = GoogleWorkspaceSupport ? [ResourceType.GoogleWorkspaceResource] : [];
    $[13] = GoogleWorkspaceSupport;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== m365BackupConsole) {
    t8 = m365BackupConsole ? [ResourceType.Microsoft365Resource] : [];
    $[15] = m365BackupConsole;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== EntraIdSupport) {
    t9 = EntraIdSupport ? [ResourceType.AzureEntraIdResource] : [];
    $[17] = EntraIdSupport;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t2 || $[20] !== t3 || $[21] !== t4 || $[22] !== t5 || $[23] !== t6 || $[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
    t10 = [ResourceType.AwsFsx, ResourceType.AwsEfs, ...t2, ...t3, ...t4, ...t5, ResourceType.AwsDocumentdb, ResourceType.AwsNeptune, ...t6, ...t7, ...t8, ...t9];
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  const ffResources = t10;
  let t11;
  if ($[28] !== cloudProviders || $[29] !== ffResources || $[30] !== isDemo || $[31] !== isDev) {
    t11 = Object.values(ResourceType).filter(x => x !== ResourceType.ResourceTypeUnspecified && (cloudProviders.length ? cloudProviders.includes(ResourceTypes[x]?.provider) : true) && (isDemo || isDev || !wipResourceTypes.includes(x) || ffResources.includes(x)));
    $[28] = cloudProviders;
    $[29] = ffResources;
    $[30] = isDemo;
    $[31] = isDev;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
};